import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useMutation } from '@apollo/client';
import { GET_FAVORITED_PRODUCT_IDS } from 'mocks/queries';
import IconHeart from 'components/icons/iconHeart';
import { colorGrayLight2, colorRed } from 'styles/layout/colors';
import useProductCardContext from 'data-hooks/useProductCardContext';
import useUserData from 'data-hooks/useUserData';
import useSetFavoriteModalState from 'global-state/favoriteModalState/useSetFavoriteModalState';
import { FAVORITE_PRODUCT_V2 } from 'mocks/mutations';

const ProductCardFavoriteButtonNew = () => {
  const product = useProductCardContext();
  const isFavorited = product?.isFavorited ?? false;

  const [toggleFavorite] = useMutation(FAVORITE_PRODUCT_V2);
  const { isLoggedIn } = useUserData();
  const setFavoriteModalState = useSetFavoriteModalState();

  const addProductToFav = useCallback((event) => {
    event.stopPropagation();
    event.preventDefault();
    if (!product.id) {
      return;
    }
    if (!isLoggedIn) {
      setFavoriteModalState({productId: product.id});
    } else {
      toggleFavorite({
        variables: {productID: product.id},
        refetchQueries: [{query: GET_FAVORITED_PRODUCT_IDS}],
      });
    }
  }, [product.id, isLoggedIn, toggleFavorite, setFavoriteModalState]);

  // Note: for the "group-hover" class to work correctly here, we require the
  // "group" class to be applied to the parent element, which is set in
  // ProductCardStatic.
  return (
    <button
      type="button"
      className={classNames(
        'w-9 h-9 rounded-full flex items-center justify-center [&_svg_path]:hover:fill-red',
        {
          'opacity-100 bg-red hover:bg-white': isFavorited,
          'opacity-0 bg-white group-hover/product-card:opacity-100': !isFavorited,
        }
      )}
      onClick={addProductToFav}
    >
      <IconHeart
        className={classNames('w-[0.875rem] ', {
          'animate-heartbeat': isFavorited,
        })}
        color={isFavorited ? colorRed : colorGrayLight2}
        fill={isFavorited ? 'white' : colorGrayLight2}
      />
    </button>
  );
};

export default ProductCardFavoriteButtonNew;